<template>
  <div class="reportDetailPage">
    <div>
      <p>&emsp;&emsp;欢迎您浏览和使用万户安智慧安全用电APP，请仔细阅读以下法律条款。如果您使用此APP，您已被视为接受和同意遵从这些条款。</p>
      <h2>法律条款</h2>
      <p>&emsp;&emsp;电CT智慧安全用电APP包含的商标属杭州善瑟科技有限公司及其关联公司（以下简称：善瑟科技公司）所有和使用，受国内法和国际法的保护，未经授权，不得复制和仿造。</p>
      <p>&emsp;&emsp;电CT智慧安全用电APP中所有设计、文字或图案等，均属杭州善瑟科技有限公司（以下简称：善瑟科技公司）所有、或已取得所有人的正式授权。在未取得相关权利人的书面同意前，任何人不得以任何形式复制、复印、传送、分发、修改电CT智慧安全用电APP上所载的内容。</p>
      <p>&emsp;&emsp;电CT智慧安全用电APP将尽可能提供准确和及时的信息和内容，但并不能保证绝对正确无误。因此，在法律允许的范围内，电CT智慧安全用电APP对信息的准确性和及时性不给予任何明示或默示的保证。善瑟科技公司不承担因您进入或使用本网站而导致的任何直接的、间接的、意外的、因果性的损害责任。请小心使用您的软件和设备。此外，善瑟科技公司对为您提供便利而设置的外部衔接内容不负任何责任。善瑟科技公司有权未经通知善瑟科技公司的用户，而对善瑟科技公司的内容做修改。</p>
      <p>&emsp;&emsp;您可以自愿选择是否在善瑟科技公司提交个人信息资料。如果您在电CT智慧安全用电APP提交个人资料，善瑟科技公司将对于您的个人资料和隐私权予以尊重和保密。</p>
      <p>&emsp;&emsp;在您的信息被用于电CT智慧安全用电APP的调查、统计、内部整体使用、发送促销信息的情况下，善瑟科技公司可能会自动收集不足以使他人辨认您个人身份的技术性资料或在您的硬盘上存储 少量的数据，上述行为的目的旨在为您提供更完善的服务。</p>
      <p>&emsp;&emsp;善瑟科技公司禁止您在电CT智慧安全用电APP传送和发放带有中伤、诽谤、造谣、色情及其他违法或不道德的资料和言论，电CT智慧安全用电APP有权对此进行管理和监督，但并不对此承担任何责任。</p>
      <p>&emsp;&emsp;电CT智慧安全用电APP无意向18岁以下未成年人提供互联网汽车清理服务或收集个人资料，并提请家长或监护人对其子女在使用互联网时进行监管和负责。由于电CT智慧安全用电APP无法辨认用户是否为未成 年人，因此如有未成年人使用电CT智慧安全用电APP网上洗涤服务，电CT智慧安全用电APP将视为获得其家长或监护人认可，任何相关后果与电CT智慧安全用电APP无关 。</p>
      <h2>隐私条款</h2>
      <p>&emsp;&emsp;电CT智慧安全用电APP隐私权保护声明是电CT智慧安全用电APP保护用户个人隐私的承诺。鉴于网络的特性，电CT智慧安全用电APP将无可避免地与您产生直接或间接的互动关系，故特此说明电CT智慧安全用电APP对用户个人信息所采取的收集、使用和保护政策，请您务必仔细阅读：</p>
      <p>&emsp;&emsp;1、使用者非个人化信息</p>
      <p>&emsp;&emsp;我们将通过您的IP地址来收集非个人化的信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集上述信息，我们也进行客流量统计，从而改进网站的管理和服务。</p>
      <p>&emsp;&emsp;2、个人资料与信息安全
      </p>
      <p>&emsp;&emsp;在使用电CT智慧安全用电APP提供的服务中，您会被要求向我们提供一些个人资料，包括使用人姓名、联系电话或手机等，以便我们及时准确地提供信息展示，请予以理解和配合。如需要更新时，也请确保资料的准确性、详实性和及时性。
      </p>
      <p>&emsp;&emsp;您的个人资料将仅限于用作展示或其它合法使用，以便我们及我们的关联企业向您提供更完善的服务。
      </p>
      <p>&emsp;&emsp;对于您所提交的个人资料，我们和我们的关联公司在未获您同意前，不会出售、出租、推销或以其它方式泄露，法律规定的情况除外。
      </p>
      <p>&emsp;&emsp;电CT智慧安全用电APP将对您所提供的资料进行严格的管理及保护，电CT智慧安全用电APP将使用相应的技术，防止您的个人资料丢失、被盗用或遭窜改。
      </p>
      <p>&emsp;&emsp;3、免责</p>
      <p>&emsp;&emsp;电CT智慧安全用电APP毋需对下列情况承担任何责任：
      </p>
      <p>&emsp;&emsp;由于您将个人资料告知他人，而导致的任何个人资料泄露；
      </p>
      <p>&emsp;&emsp;任何由于计算机2000年问题、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等；
      </p>
      <p>&emsp;&emsp;由于与电CT智慧安全用电APP链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果。
      </p>




    </div>


  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import box from "../component/box";

export default {
  name: "reportDetailPage",
  components: {  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {


  },
  created() {

  },
  mounted() {

  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.reportDetailPage {
  width: 100%;
font-size: 14px;
color: #000;
  padding:20px;
  h2{
    text-align: center;
    width: 100%;
    height: 26px;
    line-height: 26px;
  }
  p{
    margin: 4px 0;
  }
}

</style>
